CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.API_Download_v1, },
    { code: CDN.PackageCode.Control_DownloadList, },
], () => {
    $(document).ready(() => {
        let login = new CDN.Controls.Login(document.body, {
            onError: (err) => {
                console.error(err);
            },
            onLogin: (result) => {
                login.hide();
                let container = $("<div></div>");
                $("body").append(container);
                let downloadList = new CDN.Controls.DownloadList({
                    userToken: result.UserToken,
                    downloadType: CDN.API.Download.v1.DownloadType.CameraFootage,
                    dateTimeFrom: (new Date()).addMonths(-1),
                    dateTimeTo: new Date(),
                    container: container,
                });
            },
        });
    });
});